import React, { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import Title, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentTemplate from '../../ui/Content/Content';
import TeamPersonTemplate from '../../ui/TeamPerson/TeamPerson';
import { Description, Persons } from './CompanyCoursesSupport.elements';

export interface TeamProps {}

export const TEAMS = [
    {
        image: '/team_person3.webp',
        name: 'Lucie Grygerová',
        position: 'Obchodní zástupkyně',
        phones: ['+420 793 984 016'] as string[],
        mail: 'grygerova@pp.cz',
    },
    {
        image: '/team_person6.webp',
        name: 'Šárka Jurečková',
        position: 'Manažerka pro firemní kurzy',
        phones: ['+420 602 398 155'] as string[],
        mail: 'jureckova@pp.cz',
    },
];

const CompanyCoursesSupportTemplate: FC<TeamProps> = () => {
    const { t } = useTranslations();

    return (
        <ContentTemplate withPadding mobileSidePadding={20}>
            <Title tagType={TitleTagTypes.H3} isBlack>
                {t('companyCourses.support.title')}
            </Title>
            <Description>{t('companyCourses.support.description')}</Description>
            <Persons>
                {TEAMS.map((person, personKey) => (
                    <TeamPersonTemplate
                        key={personKey}
                        personKey={personKey}
                        image={person.image}
                        name={person.name}
                        position={person.position}
                        phones={person.phones}
                        mail={person.mail}
                        withoutMargin
                    />
                ))}
            </Persons>
        </ContentTemplate>
    );
};

export default CompanyCoursesSupportTemplate;
